import { render } from "./StudioDropdown.vue?vue&type=template&id=79f4c975&scoped=true&ts=true"
import script from "./StudioDropdown.vue?vue&type=script&lang=ts"
export * from "./StudioDropdown.vue?vue&type=script&lang=ts"

import "./StudioDropdown.vue?vue&type=style&index=0&id=79f4c975&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f4c975"]])

export default __exports__